import { defineMessages } from 'react-intl';

export const freightNoCarriersMessageMessages = defineMessages({
  title: {
    defaultMessage: 'No carriers are available for this shipment.',
    id: 'VxCpeN',
    description: 'Title shown when a freight quote request returns no usable carrier offers',
  },
  bodyWwex: {
    defaultMessage:
      'This shipment may be outside the supported shipping criteria, or no rates are currently available. Please review your shipment details or contact <contact>volume@wwex.com</contact> for assistance.',
    id: 'DSzuKw',
    description:
      'Body copy shown when no carriers are available for a WWEX/SpeedShip freight quote. <contact> wraps "volume@wwex.com" as a mailto link.',
  },
  bodyUnishippers: {
    defaultMessage:
      'This shipment may be outside the supported shipping criteria, or no rates are currently available. Please review your shipment details or contact your support team for assistance.',
    id: 'KjxWax',
    description: 'Body copy shown when no carriers are available for a Unishippers freight quote',
  },
});
